import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { FormGroup } from "reactstrap";
import { RadioSelectField } from "../../CommonElements";
import { API_URL } from "../../Constant";

const TransportasiBerangkat = ({ control, watch, preview }) => {
  const myParam = new URLSearchParams(window.location.search).get("22254258");
  
  // Static options (hardcode)
  const staticOptionsKeberangkatan = [
    {
      id: 1,
      name: "09:25 WIB - Citilink (Bagasi 15kg)",
      value: "09:25 WIB - Citilink (Bagasi 15kg)",
    },
    {
      id: 2,
      name: "09:50 WIB - Batik Air (Bagasi 20kg)",
      value: "09:50 WIB - Batik Air (Bagasi 20kg)",
    },
    // {
    //   id: 3,
    //   name: "Beli Sendiri (Tiket Pesawat Sendiri)",
    //   value: "Beli Sendiri (Tiket Pesawat Sendiri)",
    // },
  ];
  
  const optionsTransportasi = [
    {
      id: 1,
      name: "Berangkat sendiri",
      value: "Berangkat sendiri",
    },
    {
      id: 2,
      name: "Berangkat bersama dari Fasilkom Gedung Lama jam 06.00",
      value: "Berangkat bersama dari Fasilkom Gedung Lama jam 06.00",
    },
  ];
  const [optionsKeberangkatan, setOptionsKeberangkatan] = useState([]);

  console.log("optionsKeberangkatan", optionsKeberangkatan);
  useEffect(() => {
    if (!myParam || watch("submit")) {
      setOptionsKeberangkatan(staticOptionsKeberangkatan);
      return;
    }
    fetch(`${API_URL}cabil/cek-kuota-user/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: myParam }),
    })
      .then((res) => res.json())
      .then((data) => {
        const available = (data.kuota_maskapai || [])
          .filter((item) => item.sisa_kuota_berangkat > 0)
          .map((item, idx) => ({
            id: idx + 1,
            name: item.maskapai,
            value: item.maskapai,
          }));
        setOptionsKeberangkatan(available.length > 0 ? available : []);
      })
      .catch(() => setOptionsKeberangkatan([]));
  }, [myParam, watch("submit")]);

  return (
    <div>
      <div className="purple-header mb-4 bg-primary">
        <h3 className="text-white p-3">Transportasi Berangkat</h3>
      </div>

      <div className="form-section-content">
        <FormGroup
          style={{
            border: "1px solid #ccc",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <Controller
            name="maskapai_berangkat"
            control={control}
            rules={{ required: "Harap pilih maskapai penerbangan" }}
            render={({ field, fieldState }) => (
              <RadioSelectField
                label="Pilihan Waktu Berangkat: Kamis, 26 Juni 2025"
                fieldState={fieldState}
                options={optionsKeberangkatan}
                {...field}
                isRequired
                disabled={watch("submit") || preview}
              />
            )}
          />
        </FormGroup>

        <FormGroup
          className="mt-4"
          style={{
            border: "1px solid #ccc",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <Controller
            name="transportasi_berangkat"
            control={control}
            rules={{ required: "Harap pilih transportasi ke bandara" }}
            render={({ field, fieldState }) => (
              <RadioSelectField
                label="Transportasi: Berangkat dari Fasilkom ke Bandara (Mengingat perjalanan dan kondisi lalu lintas, dimohon tepat waktu)"
                fieldState={fieldState}
                options={optionsTransportasi}
                {...field}
                isRequired
                disabled={watch("submit") || preview}
              />
            )}
          />
        </FormGroup>
      </div>
    </div>
  );
};

export default TransportasiBerangkat;